module.exports = __webpack_public_path__ + "static/img/Group.a53f0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group.png
// module id = eo5J
// module chunks = 1